const routerConfig = {
  index: {
    meta: {
      title: '加油支付',
      sdkConfig: true,
      shouldToAuthorizeUrl: true,
      keepAlive: false
    },
    resolve: (resolve) => require(['../containers/index/index.vue'], resolve)
  },
  pay: {
    meta: {
      title: '加油支付',
      mallSdk: true,
      shouldToAuthorizeUrl: true,
      keepAlive: true
    },
    resolve: (resolve) => require(['../containers/pay/pay'], resolve)
  },
  payNp: {
    meta: {
      title: '加油支付',
      mallSdk: true,
      shouldToAuthorizeUrl: true,
      keepAlive: true
    },
    resolve: (resolve) => require(['../containers/pay/payNp'], resolve)
  },
  payJiahua: {
    meta: {
      title: '加油支付',
      shouldToAuthorizeUrl: true,
      keepAlive: true,
      mallSdk: true
    },
    resolve: (resolve) => require(['../containers/pay/payJiahua'], resolve)
  },
  invoice: {
    meta: {
      title: '发票',
      sdkConfig: true
      // shouldToAuthorizeUrl: true
    },
    resolve: (resolve) => require(['../containers/invoice/invoice'], resolve)
  },
  addInvoice: {
    meta: {
      title: '新增发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/addInvoice/addInvoice'], resolve)
  },
  editInvoice: {
    meta: {
      title: '修改发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/editInvoice/editInvoice'], resolve)
  },
  coupon: {
    meta: {
      title: '优惠券',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/coupon/coupon'], resolve)
  },
  couponDetail: {
    meta: {
      title: '优惠券',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/coupon/detail'], resolve)
  },
  couponGet: {
    meta: {
      title: '领取优惠券',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/coupon/couponGet'], resolve)
  },
  couponIssue: {
    meta: {
      title: '发放优惠券',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/coupon/couponIssue'], resolve)
  },
  login: {
    meta: {
      title: '绑定手机',
      shouldToAuthorizeUrl: true,
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/Login/Login'], resolve)
  },
  loginByThird: {
    meta: {
      title: '新客充值福利',
      shouldToAuthorizeUrl: true,
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/Login/LoginByThird'], resolve)
  },
  LoginByInvitee: {
    meta: {
      title: '新客充值福利',
      shouldToAuthorizeUrl: true,
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/Login/LoginByInvitee'], resolve)
  },
  rechargeByThird: {
    meta: {
      title: '钱包充值',
      mallSdk: true
    },
    resolve: (resolve) => require(['../containers/Recharge/rechargeByThird'], resolve)
  },
  rechargeByInvitee: {
    meta: {
      title: '钱包充值',
      mallSdk: true
    },
    resolve: (resolve) => require(['../containers/Recharge/rechargeByInvitee'], resolve)
  },
  registration: {
    meta: {
      title: '注册协议',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/registration/registration'], resolve)
  },
  recharge: {
    meta: {
      title: '钱包余额',
      shouldToAuthorizeUrl: true,
      mallSdk: true
    },
    resolve: (resolve) => require(['../containers/Recharge/Recharge'], resolve)
  },
  rechargeJiahua: {
    meta: {
      title: '钱包余额',
      mallSdk: true
    },
    resolve: (resolve) => require(['../containers/Recharge/rechargeJiahua'], resolve)
  },
  rechargeJiahuaByThirdPay: {
    meta: {
      title: '钱包余额',
      // mallSdk: true
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/Recharge/rechargeJiahuaByThirdPay'], resolve)
  },
  rechargeSuccess: {
    meta: {
      title: '钱包余额',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/Recharge/success'], resolve)
  },
  refuelingPay: {
    meta: {
      title: '加油支付',
      mallSdk: true
    },
    resolve: (resolve) =>
      require(['../containers/RefuelingPay/RefuelingPay'], resolve)
  },
  refuelingPayJiahua: {
    meta: {
      title: '加油支付',
      mallSdk: true
    },
    resolve: (resolve) =>
      require(['../containers/RefuelingPay/RefuelingPayJiahua'], resolve)
  },
  myzoe: {
    meta: {},
    resolve: (resolve) => require(['../containers/myzoe/myzoe'], resolve),
    children: {
      '': {
        meta: {
          title: '个人中心',
          shouldToAuthorizeUrl: true,
          sdkConfig: true
        },
        resolve: (resolve) => require(['../containers/myzoe/info/index'], resolve)
      },
      info: {
        meta: {
          title: '个人中心',
          shouldToAuthorizeUrl: true,
          sdkConfig: true
        },
        resolve: (resolve) => require(['../containers/myzoe/info/index'], resolve)
      },
      dev: {
        meta: {
          title: '开发中心',
          shouldToAuthorizeUrl: true,
          sdkConfig: true
        },
        resolve: (resolve) => require(['../containers/myzoe/dev'], resolve)
      },
      cvtcard: {
        meta: {
          title: '个人中心',
          shouldToAuthorizeUrl: true,
          sdkConfig: true
        },
        resolve: (resolve) => require(['../containers/myzoe/cvtcard'], resolve)
      },
      vipIntro: {
        meta: {
          title: '会员介绍',
          shouldToAuthorizeUrl: true,
          sdkConfig: true
        },
        resolve: (resolve) => require(['../containers/myzoe/vipIntro'], resolve)
      }
    }
  },
  integralcard: {
    meta: {
      title: '个人中心',
      shouldToAuthorizeUrl: true,
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/myzoe/integralcard'], resolve)
  },
  chooseRecharge: {
    meta: {
      title: '钱包充值',
      // shouldToAuthorizeUrl: true,
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/myzoe/chooserecharge'], resolve)
  },
  chooseAction: {
    meta: {
      title: '入口',
      // shouldToAuthorizeUrl: true,
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/myzoe/chooseAction'], resolve)
  },
  bindCard: {
    meta: {
      title: '绑定便捷卡',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/bind/card'], resolve)
  },
  cardRecord: {
    meta: {
      title: '便捷卡记录',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/record/card'], resolve)
  },
  setting: {
    meta: {
      title: '设置',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/setting/setting'], resolve)
  },
  successPay: {
    meta: {
      title: '加油支付',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/SuccessPay/SuccessPay'], resolve)
  },
  integral: {
    meta: {
      title: '积分兑换',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/integral/integral'], resolve)
  },
  integralDetail: {
    meta: {
      title: '积分兑换',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/integral/integralDetail'], resolve)
  },
  getIntegral: {
    meta: {
      title: '电子积分卡'
      // sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/integral/getIntegral'], resolve)
  },
  points: {
    meta: {
      title: '积分规则',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/points/points'], resolve)
  },
  detail: {
    meta: {
      title: '积分明细',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/detail/detail'], resolve)
  },
  // record: {
  //   meta: {
  //     title: '消费记录'
  //   },
  //   resolve: resolve => require(['../containers/record/record'], resolve),
  //   children: {
  //     oil: {
  //       meta: {
  //         title: '油品'
  //       },
  //       resolve: resolve => require(['../containers/record/oil'], resolve)
  //     },
  //     nonoil: {
  //       meta: {
  //         title: '非油品'
  //       },
  //       resolve: resolve => require(['../containers/record/nonoil'], resolve)
  //     }
  //   }
  // },
  record: {
    meta: {
      title: '消费记录',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/record/oil'], resolve)
  },
  recordNonOil: {
    meta: {
      title: '消费记录',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/record/nonoil'], resolve)
  },
  fuelDiary: {
    meta: {
      title: '加油记录详情',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/fuelDiary/fuelDiary'], resolve)
  },
  balance: {
    meta: {
      title: '余额明细',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/balance/balance'], resolve)
  },
  todayOilPrice: {
    meta: {
      title: '今日油价',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/todayOilPrice/todayOilPrice'], resolve)
  },
  loginByUnionId: {
    meta: {
      title: '今日油价',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/loginByUnionId/index'], resolve)
  },
  discounts: {
    meta: {
      title: '等级优惠详情',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/discounts/discounts'], resolve)
  },
  oilStation: {
    meta: {
      title: '附近油站',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/oilStation/oilStation'], resolve)
  },
  enterprise: {
    meta: {
      title: '关于企业',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/enterprise/enterprise'], resolve)
  },
  invoiceTitle: {
    meta: {
      title: '发票抬头管理',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceTitle/invoiceTitle'], resolve)
  },
  invite: {
    meta: {
      title: '好友邀请',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/invite/invite'], resolve)
  },
  sqcode: {
    meta: {
      title: '扫码关注',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/invite/sqcode'], resolve)
  },
  // 邀请好友-加华
  jhInvite: {
    meta: {
      title: '好友邀请',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/invite/index'], resolve)
  },
  bePromoter: {
    meta: {
      title: '成为推广员',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/invite/bePromoter'], resolve)
  },
  operator: {
    meta: {
      title: '申请成为运营会员',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/operator/operator'], resolve),
    children: {
      selectType: {
        meta: {
          title: '申请成为运营会员',
          num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/operator/selectType'], resolve)
      },
      basicInformation: {
        meta: {
          title: '申请成为运营会员',
          num: 2,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/operator/basicInformation'], resolve)
      },
      uploadOperator: {
        meta: {
          title: '申请成为运营会员',
          num: 3,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/operator/uploadOperator'], resolve)
      },
      operatorSuccess: {
        meta: {
          title: '申请成为运营会员',
          num: 4,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/operator/operatorSuccess'], resolve)
      }
    }
  },
  leaveWord: {
    meta: {
      title: '我要留言',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/leaveWord/leaveWord'], resolve)
  },
  leaveWordRecord: {
    meta: {
      title: '我要留言',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/leaveWord/record'], resolve)
  },
  makeInvoice: {
    meta: {
      title: '开票记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/makeInvoice/makeInvoice'], resolve)
  },
  applyInvoice: {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/applyInvoice/applyInvoice'], resolve)
  },
  'applyInvoice/result': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/applyInvoice/applyInvoiceResult'], resolve)
  },
  // 加华发票-选择
  'invoiceJiahua': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/choose/index'], resolve)
  },
  // 加华发票-申请
  'invoiceJiahua/apply': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/applyInvoice/applyInvoice'], resolve)
  },
  // 加华发票-申请确认
  'invoiceJiahua/applyCheck': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/applyInvoiceCheck/index'], resolve)
  },
  // 加华发票-申请结束
  'invoiceJiahua/applyDone': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/applyInvoice/applyInvoiceResult'], resolve)
  },
  // 加华发票-申请记录
  'invoiceJiahua/makeInvoice': {
    meta: {
      title: '开票记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/makeInvoice/makeInvoice'], resolve)
  },
  // 加华发票-申请记录
  'invoiceJiahua/makeInvoiceDetail': {
    meta: {
      title: '开票记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/makeInvoice/detail'], resolve)
  },
  // 加华发票-抬头
  'invoiceJiahua/title': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/invoiceTitle/invoiceTitle'], resolve)
  },
  // 加华发票-抬头
  'invoiceJiahua/addTitle': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/addTitle/index'], resolve)
  },
  // 加华发票-申请(便捷卡)
  'invoiceJiahuaCard/apply': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/applyInvoice/cardApplyInvoice'], resolve)
  },
  // 加华发票-申请确认(便捷卡)
  'invoiceJiahuaCard/applyCheck': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/applyInvoiceCheck/cardIndex'], resolve)
  },
  // 加华发票-申请结束(便捷卡)
  'invoiceJiahuaCard/applyDone': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/applyInvoice/cardApplyInvoiceResult'], resolve)
  },
  // 加华发票-申请记录(便捷卡)
  'invoiceJiahuaCard/makeInvoice': {
    meta: {
      title: '开票记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/makeInvoice/cardMakeInvoice'], resolve)
  },
  // 加华发票-申请记录(便捷卡)
  'invoiceJiahuaCard/makeInvoiceDetail': {
    meta: {
      title: '开票记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceJiahua/makeInvoice/cardDetail'], resolve)
  },
  // 南屏发票-申请
  'invoiceNp/apply': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceNp/applyInvoice/applyInvoice'], resolve)
  },
  // 南屏发票-申请确认
  'invoiceNp/applyCheck': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceNp/applyInvoiceCheck/index'], resolve)
  },
  // 南屏发票-申请结束
  'invoiceNp/applyDone': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceNp/applyInvoice/applyInvoiceResult'], resolve)
  },
  // 南屏发票-申请记录
  'invoiceNp/makeInvoice': {
    meta: {
      title: '开票记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceNp/makeInvoice/makeInvoice'], resolve)
  },
  // 南屏发票-申请记录
  'invoiceNp/makeInvoiceDetail': {
    meta: {
      title: '开票记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceNp/makeInvoice/detail'], resolve)
  },
  // 南屏发票-抬头
  'invoiceNp/title': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceNp/invoiceTitle/invoiceTitle'], resolve)
  },
  // 南屏发票-抬头
  'invoiceNp/addTitle': {
    meta: {
      title: '申请发票',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/invoiceNp/addTitle/index'], resolve)
  },
  allCoupon: {
    meta: {
      title: '优惠劵',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/allCoupon/allCoupon'], resolve)
  },
  indexhtm: {
    meta: {
      title: '首页分类',
      index: 1,
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/indexhtm/indexhtm'], resolve)
  },
  shopping: {
    meta: {
      title: '购物车',
      index: 2,
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/shopping/shopping'], resolve)
  },
  store: {
    meta: {
      title: '商城',
      index: 0,
      shouldToAuthorizeUrl: true,
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/store/index'], resolve)
  },
  productDetails: {
    meta: {
      title: '商品详情',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/productDetails/productDetails'], resolve)
  },
  myAddress: {
    meta: {
      title: '我的地址',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/myAddress/myAddress'], resolve)
  },
  addAddress: {
    meta: {
      title: '新增地址',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/addAddress/addAddress'], resolve)
  },
  editAddress: {
    meta: {
      title: '修改地址',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/editAddress/editAddress'], resolve)
  },
  myTaker: {
    meta: {
      title: '',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/store/taker/list'], resolve)
  },
  editTaker: {
    meta: {
      title: '',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/store/taker/edit'], resolve)
  },
  afterSale: {
    meta: {
      title: '申请售后',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/afterSale/afterSale'], resolve)
  },
  search: {
    meta: {
      title: '搜索',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/search/search'], resolve)
  },
  personalCenter: {
    meta: {
      title: '个人中心',
      index: 3,
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/personalCenter/personalCenter'], resolve)
  },
  sendBack: {
    meta: {
      title: '订单售后',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/sendBack/sendBack'], resolve)
  },
  amOrder: {
    meta: {
      title: '订单售后',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/amOrder/amOrder'], resolve)
  },
  account: {
    meta: {
      title: '订单详情',
      mallSdk: true,
      shouldToAuthorizeUrl: true
    },
    resolve: (resolve) => require(['../containers/account/account'], resolve)
  },
  allOrder: {
    meta: {
      title: '全部订单',
      mallSdk: true,
      shouldToAuthorizeUrl: true
    },
    resolve: (resolve) => require(['../containers/allOrder/allOrder'], resolve)
  },
  giftPacks: {
    meta: {
      title: '大礼包',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/giftPacks/giftPacks'], resolve)
  },
  storeCoupon: {
    meta: {
      title: '优惠劵',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/storeCoupon/storeCoupon'], resolve)
  },
  orderClose: {
    meta: {
      title: '订单结算',
      mallSdk: true,
      shouldToAuthorizeUrl: true
    },
    resolve: (resolve) =>
      require(['../containers/orderClose/orderClose'], resolve)
  },
  finish: {
    meta: {
      title: '结算成功',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/finish/finish'], resolve)
  },
  mallCoupon: {
    meta: {
      title: '领取商城优惠劵',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/mallCoupon/mallCoupon'], resolve)
  },
  orderCoupon: {
    meta: {
      title: '领取商城优惠劵',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/orderCoupon/orderCoupon'], resolve)
  },
  logistics: {
    meta: {
      title: '查看物流',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/logistics/logistics'], resolve)
  },
  // 免密支付
  noScrectPayment: {
    meta: {
      title: '免密支付设置',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/noScrectPayment/noScrectPayment'], resolve)
  },
  noScrectPaymentAgreement: {
    meta: {
      title: '免密支付说明'
    },
    resolve: (resolve) =>
      require(['../containers/noScrectPayment/agreement'], resolve)
  },
  noScrectPaymentSuccess: {
    meta: {
      title: '支付完成',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/noScrectPayment/paymentSuccess'], resolve)
  },
  // 加华定制部分
  jiahuaAd: {
    meta: {
      title: '详情',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/jiahua/ad'], resolve)
  },
  jiahuaRefuel: {
    meta: {
      title: '扫码支付',
      // sdkConfig: true,
      shouldToAuthorizeUrl: true,
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/jiahua/refuel/refuel'], resolve)
  },
  jiahuaRefuelNosupport: {
    meta: {
      title: '扫码支付',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/jiahua/refuel/nosupport'], resolve)
  },
  jiahuaRefuelConfirm: {
    meta: {
      title: '确认支付',
      // mallSdk: true
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/jiahua/refuel/confirm'], resolve)
  },
  jiahuaRefuelCoupon: {
    meta: {
      title: '选择优惠券',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/jiahua/refuel/coupon'], resolve)
  },
  jiahuaRefuelPaySuccess: {
    meta: {
      title: '支付成功',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/jiahua/refuel/paySuccess'], resolve)
  },
  jiahuaRefuelPaySuccess2: {
    meta: {
      title: '支付成功',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/jiahua/refuel/paySuccess2'], resolve)
  },
  // 加华定制部分 end
  // 二手车平台
  usedCar: {
    meta: {
      title: '二手车平台',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/usedCar/index'], resolve)
  },
  'usedCar/detail': {
    meta: {
      title: '二手车平台',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/usedCar/detail'], resolve)
  },
  'usedCar/form': {
    meta: {
      title: '二手车平台',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/usedCar/form'], resolve)
  },
  'usedCar/setting': {
    meta: {
      title: '二手车平台',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/usedCar/setting'], resolve)
  },
  // 二手车平台 end
  // 新二手车平台
  usedCarII: {
    resolve: (resolve) => require(['../containers/usedCar2/index'], resolve),
    children: {
      home: {
        meta: {
          title: '二手车平台',
          shouldToAuthorizeUrl: true
        },
        resolve: (resolve) => require(['../containers/usedCar2/home'], resolve)
      },
      form: {
        meta: {
          title: '卖车估价',
          sdkConfig: true,
          shouldToAuthorizeUrl: true
        },
        resolve: (resolve) => require(['../containers/usedCar2/form'], resolve)
      },
      myzoe: {
        meta: {
          title: '个人中心',
          shouldToAuthorizeUrl: true
        },
        resolve: (resolve) =>
          require(['../containers/usedCar2/myzoe'], resolve)
      }
    }
  },
  'usedCarII/detail': {
    meta: {
      title: '车辆详情'
    },
    resolve: (resolve) => require(['../containers/usedCar2/detail'], resolve)
  },
  'usedCarII/msg': {
    meta: {
      title: '消息通知'
    },
    resolve: (resolve) => require(['../containers/usedCar2/msg'], resolve)
  },
  'usedCarII/result': {
    meta: {
      title: '卖车估价'
    },
    resolve: (resolve) => require(['../containers/usedCar2/result'], resolve)
  },
  // 新二手车平台 end
  // 旧系统闪付卡
  ccLogin: {
    meta: {
      title: '便捷卡登录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/ccLogin'], resolve)
  },
  bingCard: {
    meta: {
      title: '便捷卡绑定',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/bingCard'], resolve)
  },
  bingCardSuccess: {
    meta: {
      title: '便捷卡绑定',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/bingCardSuccess'], resolve)
  },
  findPassword: {
    meta: {
      title: '重置密码',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/findPassword'], resolve)
  },
  resviePassword: {
    meta: {
      title: '修改密码',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/resviePassword'], resolve)
  },
  resviePassword2: {
    meta: {
      title: '修改密码',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/resviePassword2'], resolve)
  },
  againBingPhone: {
    meta: {
      title: '更换绑定',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/againBingPhone'], resolve)
  },
  againBingPhone2: {
    meta: {
      title: '绑定手机',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/againBingPhone2'], resolve)
  },
  rechargeCard: {
    meta: {
      title: '余额充值',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/rechargeCard'], resolve)
  },
  rechargeCardCheck: {
    meta: {
      title: '加华手机站',
      mallSdk: true,
      shouldToAuthorizeUrl: true
      // sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/rechargeCardCheck'], resolve)
  },
  rechargeCardSuccess: {
    meta: {
      title: '加华手机站',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/rechargeCardSuccess'], resolve)
  },
  resvieDetail: {
    meta: {
      title: '个人信息',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/resvieDetail'], resolve)
  },
  ingetralCheck: {
    meta: {
      title: '积分明细',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/ingetralCheck'], resolve)
  },
  moneyChongCheck: {
    meta: {
      title: '充值记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/moneyChongCheck'], resolve)
  },
  moneyXiaoCheck: {
    meta: {
      title: '消费记录',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/moneyXiaoCheck'], resolve)
  },
  moneyXiaoCheckDetail: {
    meta: {
      title: '消费记录详情',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/moneyXiaoCheckDetail'], resolve)
  },
  vipCenter: {
    meta: {
      title: '会员中心',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/vipCenter'], resolve)
  },
  CleaveWord: {
    meta: {
      title: '留言和查阅',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/CleaveWord'], resolve),
    children: {
      '': {
        meta: {
          title: '留言和查阅',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/ConvenienceCard/writeLeaveWord'], resolve)
      },
      writeLeaveWord: {
        meta: {
          title: '留言和查阅',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/ConvenienceCard/writeLeaveWord'], resolve)
      },
      checkLeaveWord: {
        meta: {
          title: '加华手机站',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/ConvenienceCard/checkLeaveWord'], resolve)
      }
    }
  },
  cardAllCoupon: {
    meta: {
      title: '优惠劵',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/ConvenienceCard/allCoupon/allCoupon'], resolve)
  },
  // 便捷卡优惠券
  cardCoupon: {
    meta: {
      title: '优惠券',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/ConvenienceCard/coupon/coupon'], resolve)
  },
  // 便捷卡优惠券详情
  cardCouponDetail: {
    meta: {
      title: '优惠券',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/ConvenienceCard/coupon/detail'], resolve)
  },
  // 便捷卡挂失-验证密码
  cardNewCardCheckPwd: {
    meta: {
      title: '旧卡挂失',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/ConvenienceCard/newCard/checkPwd'], resolve)
  },
  // 便捷卡挂失-输入新卡号
  cardNewCard: {
    meta: {
      title: '旧卡挂失',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/ConvenienceCard/newCard/newCard'], resolve)
  },
  // 便捷卡挂失-挂失完成
  cardNewCardDone: {
    meta: {
      title: '旧卡挂失',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/ConvenienceCard/newCard/newCardDone'], resolve)
  },

  // ----------------------------------  便捷卡申请 -----------------------------
  // 便捷卡申请-入口
  cardApply: {
    meta: {
      title: '便捷卡申请',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/ConvenienceCard/apply/index'], resolve)
  },
  'cardApply/form': {
    meta: {
      title: '便捷卡申请'
      // sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/ConvenienceCard/apply/form'], resolve)
  },
  'cardApply/formDone': {
    meta: {
      title: '便捷卡申请',
      sdkConfig: true
    },
    resolve: (resolve) => require(['../containers/ConvenienceCard/apply/success'], resolve)
  },

  // 生日登记
  birthdayMark: {
    meta: {
      title: '生日优惠券登记',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/BirthdayMark/index'], resolve),
    children: {
      '': {
        meta: {
          title: '生日优惠券登记',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/BirthdayMark/Mark'], resolve)
      },
      done: {
        meta: {
          title: '生日优惠券登记',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/BirthdayMark/MarkDone'], resolve)
      }
    }
  },
  // 企业会员申请
  corporateMember: {
    meta: {
      title: '企业会员申请',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/CorporateMember/index'], resolve),
    children: {
      '': {
        meta: {
          title: '企业会员申请',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/CorporateMember/MarkByCode'], resolve)
      },
      mark: {
        meta: {
          title: '企业会员申请',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/CorporateMember/Mark'], resolve)
      },
      done: {
        meta: {
          title: '企业会员申请',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/CorporateMember/MarkDone'], resolve)
      },
      info: {
        meta: {
          title: '企业会员',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/CorporateMember/Info'], resolve)
      }
    }
  },
  // 服务评价
  serviceEvaluation: {
    meta: {
      title: '服务评价',
      sdkConfig: true
    },
    resolve: (resolve) =>
      require(['../containers/serviceEvaluation/index'], resolve),
    children: {
      '': {
        meta: {
          title: '服务评价',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/serviceEvaluation/mark'], resolve)
      },
      done: {
        meta: {
          title: '服务评价',
          // num: 1,
          sdkConfig: true
        },
        resolve: (resolve) =>
          require(['../containers/serviceEvaluation/markDone'], resolve)
      }
    }
  },
  // 开发者页面
  dev: {
    meta: {
      title: 'dark'
    },
    resolve: (resolve) => require(['../containers/dev/index'], resolve)
  },
  // 维护页面
  maintain: {
    meta: {
      title: '系统维护中'
    },
    resolve: (resolve) => require(['../containers/maintain/index'], resolve)
  },
  // notfound
  notfound: {
    meta: {
      title: '404'
    },
    resolve: (resolve) => require(['../containers/notfound/index'], resolve)
  }
}
export default routerConfig



// WEBPACK FOOTER //
// ./src/router/controller.js